import React from "react";
import { View } from "react-native";
import Image from "react-native-fast-image";
import { useSelector } from "react-redux";
import metrics from "@constants/metrics";
import Draggable from "react-native-draggable";
import { DrawerActions } from "@react-navigation/native";
import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";
import handleCMSNavigation from "@utils/handleCMSNavigation";
import useLeaderState from "@hooks/useLeaderState";
import NavigationService from "../utils/NavigationService";

const SupportButton = (props) => {
  const { currentRouteName = "" } = useSelector(({ navigation }) => navigation);
  const { canUseFeature } = useLeaderState();
  const link =
    "https://unwtb.app.link/Q3hbz6Jdxbb?entityId=25408&app_screen=DynamicCMSListing&app_name=cl";
  const linkType = "INTERNAL";
  const onPressSupport = () => {
    if (!canUseFeature(["LEADER_SUSPENDED"])) {
      handleCMSNavigation(link, linkType);
      return;
    }
    if (NavigationService && typeof NavigationService.navigate === "function") {
      analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_STARTED, {
        source: "Icon",
      });
      NavigationService.dispatch(DrawerActions.closeDrawer());
      NavigationService.navigate("SupportTree", { headerName: "Support" });
    }
  };

  const shouldShowSupportButton =
    ["Orders", "Home"].indexOf(currentRouteName) === -1;
  if (shouldShowSupportButton) {
    return <View />;
  }

  return (
    <Draggable
      maxX={metrics.screenWidth - 8}
      minX={8}
      maxY={metrics.screenHeight - 48}
      minY={48}
      x={metrics.screenWidth - 80}
      y={metrics.screenHeight - 260}
      renderSize={56}
      z={100000}
      onShortPressRelease={onPressSupport}
      onDrag={() => {}}
      onDragRelease={() => {}}
      onLongPress={() => {}}
      onPressIn={() => {}}
      onPressOut={() => {}}
      onRelease={() => {}}
    >
      <Image
        source={require("../assets/images/SupportIcon.webp")}
        style={{
          width: 76,
          height: 66,
        }}
      />
    </Draggable>
  );
};

export default SupportButton;
